import React, { Component } from 'react'
import Lazyload from '@components/common/Lazyload/Lazyload'
// import dateFormat from 'dateformat'
import _get from 'lodash/get'

// import { getContentTypeName } from '@source/lib/globalUtil'

import { placeholderBlankLandscape } from '@global/imageUrl'

import { playlistContainer, ProgressBar, imageWrapper, SpecialRibbon } from './style'

class ResumeVideoCard extends Component {
  state = {
    show: false,
  }

  handleTitleShow = (show = false) => {
    this.setState({ show: show === 'success' ? true : false })
  }

  render() {
    const {
        id,
        type,
        title = '',
        description = '',
        duration,
        timePosition = 0,
        src,
        onClick = () => {},
        containerClassName = '',
        className = '',
        transitionMode = 'scroll',
        ribbon,
      } = this.props, 
      { show } = this.state

    const placeholderBlankSquare = 'https://res-mola01.koicdn.com/image/55540e63-f7df-44ce-9553-6c1e4d9bc559/image.png'
    const barWidth = duration && timePosition ? `${Math.floor((timePosition / (duration * 60)) * 100)}%` : '0%'
    return (
      <div
        onClick={() => onClick()}
        className={`${playlistContainer} ${containerClassName} ${transitionMode === 'scroll' ? '' : 'hoverOff'}`}
      >
        <div className={`${imageWrapper} resumeWrapper`}>
          {ribbon && <SpecialRibbon imgUrl={ribbon} />}
          <Lazyload
            className={`${transitionMode === 'scroll' ? 'bannerImage' : 'bannerImage3d'}`}
            src={src}
            fallbackImageUri={`${placeholderBlankSquare}?w=640&h=360`}
            onHoverBorder
          />
          <ProgressBar width={barWidth}>
            <span />
          </ProgressBar>
        </div>
        {title && <p className={'title'}>{title}</p>}
        {/* {description && <p className={'shortDesc'}>{description}</p>} */}
      </div>
    )
  }
}

export default ResumeVideoCard
